import { render, staticRenderFns } from "./sendWays.vue?vue&type=template&id=063293b9&scoped=true&"
import script from "./sendWays.vue?vue&type=script&lang=js&"
export * from "./sendWays.vue?vue&type=script&lang=js&"
import style0 from "./sendWays.vue?vue&type=style&index=0&id=063293b9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063293b9",
  null
  
)

export default component.exports